import { useNavigate } from "react-router-dom";
import Paragraph from "../paragraph/Paragraph";
import { ContentFormatType } from "../../types";
import { ROUTES } from "../../constants/routes";
import { useSortedContentFormats } from "../../hooks/useSortedContentFormats";

const LoggedOutNavigation: React.FC<{ close: () => void }> = ({ close }) => {
  const navigate = useNavigate();
  const { data: sortedContentFormats } = useSortedContentFormats();

  const onPress = (page: string) => {
    navigate(page);
    close();
  };

  return (
    <>
      <h3>Sadržaj</h3>
      <ul>
        <li onClick={() => onPress(ROUTES.content)}>
          <Paragraph variant="title">Sve epizode</Paragraph>
        </li>
        {sortedContentFormats?.map((contentFormat: ContentFormatType) => {
          return (
            <li key={contentFormat.name}>
              <Paragraph
                onClick={() =>
                  onPress(
                    `${ROUTES.content}?contentFormatIds=${contentFormat.id}`
                  )
                }
                variant="title"
              >
                {contentFormat.name}
              </Paragraph>
            </li>
          );
        })}
      </ul>
      <h3>Kompanija</h3>
      <ul>
        <li onClick={() => onPress(ROUTES.aboutUs)}>
          <Paragraph variant="title">O nama</Paragraph>
        </li>
        <li onClick={() => onPress(ROUTES.educators)}>
          <Paragraph variant="title">Edukatori</Paragraph>
        </li>
      </ul>
    </>
  );
};

export default LoggedOutNavigation;
